import { types } from "../../types/types";
import { fetchConToken } from "../../helpers/fetch";
import { startSpinner, finishSpinner } from "../ui/spinner";

const movimientosUserTraerStart = () => ({
  type: types.movimientosUserTraerStart,
});
export const movimientosUserLimpiar = () => ({ type: types.movimientosUserLimpiar });
export const movimientosUserTraerSuccess = (payload) => {
  return {
    type: types.movimientosUserTraerSuccess,
    payload: payload,
  };
};

export const traerMovimientosUser = () => {
  return async (dispatch) => {
    dispatch(startSpinner());
    dispatch(movimientosUserTraerStart());
    const response = await fetchConToken(`RegistroModificaciones/`)
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      const lista = await response.json();
      dispatch(movimientosUserTraerSuccess(lista))
    }
    dispatch(finishSpinner());
  };
};

export const registroUser = (data) => {
    return async (dispatch) => {
      dispatch(startSpinner());
      dispatch(movimientosUserTraerStart());
      const response = await fetchConToken(`RegistroModificaciones/`,data,'POST')
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        dispatch({
            type:types.registroUserSuccess
        })
      }
      dispatch(finishSpinner());
    };
  };

  export const buscarMovimientoUser = (text) =>(dispatch)=>{
    dispatch({
      type:types.movimientosFindSucces,
      payload:text
    });
 
 }